import { render, staticRenderFns } from "./FichaIdentificacion.vue?vue&type=template&id=a218f4e0&"
import script from "./FichaIdentificacion.vue?vue&type=script&lang=js&"
export * from "./FichaIdentificacion.vue?vue&type=script&lang=js&"
import style0 from "./FichaIdentificacion.vue?vue&type=style&index=0&id=a218f4e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports